export default __webpack_public_path__ + "static/lincoln_agency_logo-347e455ef1e39a538d15379f185141c2.png";